import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { KHTV } from '../../models/customer.model';

@Component({
  selector: 'app-khtv',
  templateUrl: './khtv.component.html',
  styleUrls: ['./khtv.component.css']
})
export class KhtvComponent implements OnInit {
  customer: KHTV;
  public listener: () => void;
  @Input() cust: KHTV;
  @Output('change') custChange = new EventEmitter<KHTV>();
  constructor(private renderer: Renderer2) {
    // this.name = `Angylar! v${VERSION.full}`

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/khtv/khtv.component.ts